module.exports = __webpack_public_path__ + "assets/ic_tree29.816086c2.svg";